import { createLazyFileRoute } from "@tanstack/react-router";
import { FileSpreadsheetIcon, FileTextIcon } from "lucide-react";

import { trpc } from "@blis/trpc/react";

import { LoadingPage } from "@/components/LoadingPage";
import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { buttonVariants } from "@/components/ui/button";
import { InvoicePreview } from "@/features/admin/components/billing/InvoicePreview";
import { Section } from "@/features/admin/components/Section";
import { getApiUrl } from "@/lib/api";

export const Route = createLazyFileRoute(
  "/_auth/admin/billing/invoices/preview/$orgId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const { data, isPending } = trpc.admin.billing.getPreviewInvoice.useQuery({
    orgId,
  });

  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/billing" }}>Billing</Breadcrumb>
            <Breadcrumb>Invoice Preview</Breadcrumb>
          </>
        }
        actions={
          <div className="flex items-center gap-2">
            <a
              href={getApiUrl(`/api/invoice/preview/${orgId}?type=pdf`)}
              className={buttonVariants({ variant: "outline", size: "sm" })}
              target="_blank"
              rel="noopener"
            >
              <FileTextIcon />
              PDF
            </a>
            <a
              href={getApiUrl(`/api/invoice/preview/${orgId}?type=excel`)}
              className={buttonVariants({ variant: "outline", size: "sm" })}
              target="_blank"
              rel="noopener"
            >
              <FileSpreadsheetIcon />
              Excel
            </a>
          </div>
        }
      >
        Invoice Preview
      </Section.Title>
      {isPending ? (
        <LoadingPage />
      ) : (
        <InvoicePreview invoice={data} isPreview />
      )}
    </>
  );
}
